<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            d="M9.01146 8.89142C9.65321 8.89142 9.9409 8.8745 9.99659 8.87038L9.99473 8.86993C11.9636 8.78397 13.4323 8.44564 13.4323 8.04146C13.4323 7.63729 11.9631 7.29896 9.99473 7.21254V8.53388C9.93951 8.53891 9.63279 8.56405 9.02027 8.56405C8.50984 8.56405 8.14047 8.54256 8.01147 8.53342V7.21163C6.03889 7.2985 4.56653 7.63638 4.56653 8.04146C4.56653 8.44655 6.03889 8.78489 8.01147 8.87038C8.13862 8.87633 8.50102 8.89142 9.01146 8.89142Z"
            fill="#50AF95"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.13681 8.26002L4.00868 2.3163C4.01808 2.29629 4.03316 2.27937 4.0521 2.26761C4.07103 2.25585 4.09302 2.24973 4.11541 2.25001H13.8855C13.9078 2.24995 13.9296 2.25622 13.9484 2.26805C13.9671 2.27989 13.9821 2.2968 13.9913 2.31676L16.8632 8.26048C16.8741 8.28259 16.8776 8.30756 16.8731 8.33175C16.8686 8.35593 16.8563 8.37806 16.8381 8.3949L9.0819 15.7176C9.05987 15.7384 9.03053 15.75 9 15.75C8.96948 15.75 8.94013 15.7384 8.9181 15.7176L1.16186 8.39444C1.14368 8.3776 1.13143 8.35547 1.12692 8.33129C1.12242 8.3071 1.12588 8.28213 1.13681 8.26002ZM9.99659 5.89304V7.07584C12.2251 7.17738 13.8995 7.61218 13.8995 8.13382C13.8995 8.6555 12.2235 9.09076 9.99612 9.1918V12.9834H8.01101V9.19317C5.77857 9.09167 4.09971 8.65641 4.09971 8.13428C4.09971 7.61214 5.77857 7.17642 8.01101 7.07538V5.89304H5.26443V4.08935H12.7436V5.89304H9.99659Z"
            fill="#50AF95"
        />
    </svg>
</template>
